import { EMPTY_OBJECT } from '../../constants/common'
import {
  SUBMENU_DEFAULT_VALUE,
  SUBMENU_PARAM_ARCHIVE_VALUE,
} from '../../constants/route'

function prepareHeaderInfoItemValue(value) {
  return value
}

// A tab without a permission key is visible to everyone who can open the profile.
function getCanViewEntityProfileTab({ permissionKey, permissions }) {
  return !permissionKey || Boolean(permissions[permissionKey])
}

export function getEntityProfileHeaderInfoItemInitialValues({
  name,
  prepareValue = prepareHeaderInfoItemValue,
  value,
}) {
  return {
    [name]: prepareValue(value),
  }
}

export function getEntityProfileTabTotalCount(counter) {
  return counter?.total
}

// Counters without a sub-menu breakdown only have `total`, which is already active-only.
export function getEntityProfileTabActiveCount(counter) {
  return counter?.all?.total ?? counter?.total
}

// "All" / "Archive" sub-tab counts of a section with a sub-menu breakdown.
export function getEntityProfileSubTabCounters(counter) {
  return {
    [SUBMENU_DEFAULT_VALUE]: counter?.all?.total,
    [SUBMENU_PARAM_ARCHIVE_VALUE]: counter?.archived?.total,
  }
}

export function getEntityProfileTabs({
  counters,
  entityData,
  isCountersLoading = false,
  t,
  tabs,
}) {
  const permissions = entityData?.permissions || EMPTY_OBJECT

  return tabs.reduce(
    (
      acc,
      {
        counterSection,
        getCount = getEntityProfileTabTotalCount,
        getIsVisible = null,
        id,
        permissionKey,
        qaName,
        titleKey,
      }
    ) => {
      if (
        !getCanViewEntityProfileTab({ permissionKey, permissions }) ||
        (getIsVisible && !getIsVisible(entityData))
      ) {
        return acc
      }

      acc.push({
        count: getCount(counters?.[counterSection]),
        id,
        isCountLoading: isCountersLoading && Boolean(counterSection),
        qaName,
        text: t(titleKey),
      })

      return acc
    },
    []
  )
}

export function getHasEntityProfileTabCounters({ entityData, tabs }) {
  return (
    Object.keys(getEntityProfileTabCountersParams({ entityData, tabs }))
      .length > 0
  )
}

export function getEntityProfileTabCountersParams({
  entityData,
  tabId = null,
  tabs,
}) {
  const permissions = entityData?.permissions || EMPTY_OBJECT

  return tabs.reduce(
    (acc, { counterSection, getIsVisible = null, id, permissionKey }) => {
      if (
        (!tabId || tabId === id) &&
        counterSection &&
        getCanViewEntityProfileTab({ permissionKey, permissions }) &&
        (!getIsVisible || getIsVisible(entityData))
      ) {
        acc[counterSection] = true
      }

      return acc
    },
    {}
  )
}
